import { useEffect, useState } from 'react'
import { Drawer } from 'antd'
import { useLocation } from 'react-router'
import Sidebar from '../Components/Shared/Sidebar'
import Header from '../Components/Shared/Header'
import { Outlet } from 'react-router'
import useIsMobile from '../Utils/useIsMobile'

const Dashboard = () => {
    const isMobile = useIsMobile()
    const location = useLocation()
    const [collapsed, setCollapsed] = useState(false)
    const [mobileOpen, setMobileOpen] = useState(false)
    const sidebarWidth = collapsed ? 80 : 300

    /* Close the mobile drawer whenever the route changes. */
    useEffect(() => { setMobileOpen(false) }, [location.pathname])

    const onToggle = () => (isMobile ? setMobileOpen((prev) => !prev) : setCollapsed((prev) => !prev))

    return (
        <div className='flex h-screen overflow-hidden'>
            {!isMobile && (
                <div
                    style={{ width: sidebarWidth }}
                    className='h-screen shrink-0 box-border bg-[var(--primary-bg)] transition-[width] duration-200'
                >
                    <Sidebar collapsed={collapsed} />
                </div>
            )}

            {isMobile && (
                <Drawer
                    placement='left'
                    open={mobileOpen}
                    onClose={() => setMobileOpen(false)}
                    closable={false}
                    styles={{ wrapper: { width: 280 }, body: { padding: 0, background: 'var(--primary-bg)' } }}
                >
                    <Sidebar collapsed={false} onNavigate={() => setMobileOpen(false)} />
                </Drawer>
            )}

            <div
                style={{ width: isMobile ? '100%' : `calc(100% - ${sidebarWidth}px)` }}
                className='h-screen transition-[width] duration-200'
            >
                <Header collapsed={collapsed} isMobile={isMobile} onToggle={onToggle} />
                <div className='w-full p-3 md:p-5 rounded-md h-[calc(100dvh-72px)] overflow-auto'>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Dashboard
